import React, { useEffect } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import Button from './Button';
import './ResolverPanel.css';

smoothscroll.polyfill();
const ResolverPanel = ({ onClickHandler, onCloseHandler }) => {
    useEffect(() => {
        document.getElementById('textarea').focus();
    });

    function onFocus() {
        const scrollTop = (window.screen.height / 100) * 11;
        setTimeout(() => {
            window.scrollTo({
                top: scrollTop,
                behavior: 'smooth',
            });
        }, 500);
    }

    function getTextArea() {
        const textArea = document.getElementById('textarea').value;
        onClickHandler(textArea);
        onCloseHandler();
    }

    function enterToSubmit(e) {
        if (e.charCode === 13) {
            getTextArea();
        }
    }

    return (
        <div className="resolver-panel__container">
            <div className="resolver-panel">
                <label htmlFor="textarea" className="resolver-panel__label">Tu respuesta:
                    <textarea id="textarea" name="textarea" className="resolver-panel__input" onTouchStart={onFocus} onKeyPress={(e) => enterToSubmit(e)} />
                </label>
                <div>
                    <Button text="Resolver" type="resolver-panel__button--resolver" onClickHandler={getTextArea} />
                    <Button text="Cerrar" type="resolver-panel__button--cancel" onClickHandler={onCloseHandler} />
                </div>
            </div>
        </div>
    );
};

export default ResolverPanel;
